/*
 * Constants
 ***************************/
 var $ = jQuery.noConflict()
 const mobileBreakpoint = 767;
 let scrollTop = $(window).scrollTop(),
     navTrigger = 0;

 /*
  * Viewport height adjustments
  ***************************/
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
 // We execute the same script as before
 let vh = window.innerHeight * 0.01;
 document.documentElement.style.setProperty('--vh', `${vh}px`);
});

/*
 * Globals
 ***************************/
  /* Window */
    var windowWidth = $(window).width();
    var windowHeight = $(window).height();
    var windowScrollHeight = document.querySelector('body').scrollHeight;
  /* Breakpoints */
    var isMobile = ( windowWidth <= mobileBreakpoint );
  /* Navigation */
    var isMenuOpen = false,
        isTakeoverMenuOpen = false,
        isSearchOpen = false;

  /* Ajax */
    let currentPage = 1;
    let ajaxIsLoading = false;
    let isDoneLoadingThings = false;
    let currentUrl = window.location.href;

  /* Slick Options */
    const prevArrow = '<button type="button" class="slick-big-arrow slick-prev"><span class="screen-reader-text">One</span></button>';
    const nextArrow = '<button type="button" class="slick-big-arrow slick-next"><span class="screen-reader-text">two</span></button>';
    
    
    
    
    // <div class="arrow-container">
    //     <button class="prev slick-arrow">prev</button>
    //     <button class="next slick-arrow">next</button>
    // </div>
    


const handleKeypressADA = function() {
  const keycode = (event.keyCode ? event.keyCode : event.which);
  if (keycode == '13') return;
  $(this).trigger('click');
};

$(window).on('load', function() {
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
});

$(document).ready(function(){
  const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

  /* Generic */
  if ( $('.modal-area').length ) {
    $('.modal-area').each(function(){
      const prop = $(this).data('propid');

      $(this).find('.modal-area__dismiss').on('click', function(){
        $(this).closest('.modal-area').removeClass('active');
        window.localStorage.setItem( prop, 'true' );
      }).on('keypress', handleKeypressADA);

      const element = $(this).get(0);

      $(this).on('click', function(e){
        if (e.target !== element && !element.contains(e.target)) {
          $(this).removeClass('active');
          window.localStorage.setItem( prop, 'true' );
        }
      });

      const modalDismissed = window.localStorage.getItem( prop );
      if ( modalDismissed != 'true' ) {
        const modal = $(this);
        setTimeout(function(){
          modal.addClass('active');
        }, $(this).data('delay'));
      }
    });
  }

  if ( $('.wp-block-navigation').length ) {
    $('.wp-block-navigation').on('click', 'a', function(e){
      if ( this.hasAttribute('href') && $(this).attr('href').indexOf('#') !== 0 ) return;
      e.preventDefault();

      const el = $( $(this).attr('href') );
      console.log(el);
      let target = $( $(this).attr('href') ).offset().top - ($(this).hasClass('microsite-nav__item-link') ? 80 : 148);
      let dist = Math.abs($(window).scrollTop() - target);

      if ( isMobile ) {
        $('.wp-block-navigation__responsive-container-close').trigger('click');
      }

      $([document.documentElement, document.body]).animate({
        scrollTop: target
      }, Math.min(1200, ((dist / 1200) * 1000)), 'swing', function(){
        el.focus();
      });
    })
  }
 


  if ( $('.smooth-scroller').length ) { // internal links, smooth scrolling
    $('.smooth-scroller').on('click', function(e){
      e.preventDefault();
      const el = $( $(this).attr('href') );
      let target = $( $(this).attr('href') ).offset().top - ($(this).hasClass('microsite-nav__item-link') ? 80 : 148);
      let dist = Math.abs($(window).scrollTop() - target);

      $([document.documentElement, document.body]).animate({
        scrollTop: target
      }, Math.min(1200, ((dist / 1200) * 1000)), 'swing', function(){
        el.focus();
      });
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.copybutton').length ) {
    $('.copybutton').on('click', function(e){
      e.preventDefault();
      const targetEl = $( $(this).data('target') ).get(0);
      const alertEl = $( $(this).data('alert') ).get(0);
      targetEl.select()
      targetEl.setSelectionRange(0, 9999999);
      document.execCommand("copy");
      $(alertEl).fadeIn();
      setTimeout(function(){
        $(alertEl).fadeOut();
      }, 6000);
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.modaltrigger').length ) {
    $('.modaltrigger').on('click', function(e){
      e.preventDefault();
      $(this).addClass('active');
      $(this).attr('aria-expanded', true );
      $($(this).attr('href')).addClass('active');
      $('#masthead').removeClass('scrolled-back');
      $('#masthead').addClass('scrolled');
      $('body').addClass('no-scroll');
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.modalclose').length ) {
    $('.modalclose').on('click', function(e){
      e.preventDefault();
      const controlledBy = $(this).data('controlledby');
      $(this).closest('.modal').removeClass('active');
      $(controlledBy).removeClass('active');
      $(controlledBy).attr('aria-expanded', false);
      $('body').removeClass('no-scroll');
    }).on('keypress', handleKeypressADA);
  }
  /* END GENERIC SCRIPTS */
  /* START ACTION FUND SCRIPTS */

  $('.action-fund-open-menu').click(function(){
    $('.action-fund-mobile-menu').toggleClass('active');
    $('#action-fund-navigation').toggleClass('open-menu-nav');
    $('.action-fund-open-menu').toggleClass('hide');
    $('body').css("overflow", 'hidden');
  });

  $('.action-fund-menu-close').click(function(){
    $('.action-fund-mobile-menu').removeClass('active');
    $('.action-fund-open-menu').toggleClass('hide');
    $('body').css("overflow", 'initial');
    $('#action-fund-navigation').toggleClass('open-menu-nav');
  });
  /* END ACTION FUND SCRIPTS */

  /* GUTENBERG BLOCK SCRIPTS */
  // gallery
  if ( $('.wp-block-gallery').length ) {
    $('.wp-block-gallery').each(function(){
      gutenbergSlickify(this);
    });
  }

  //accordion
  if ( $('.accordion-inner').length ) {
    $('.accordion-inner').each(function(){
      const toggle = $(this).find('.accordion-inner__title button');
      const title = $(this).find('.accordion-inner__title');
      const content = $(this).find('.accordion-inner__content');

      if ( ! content.hasClass('open-on-load') ) {
        content.hide();
      }

      toggle.on('click', function(){
        content.slideToggle();
        const expanded = $(this).attr('aria-expanded');
        $(this).attr('aria-expanded', expanded == 'true' ? 'false' : 'true');
        title.toggleClass('expanded');
      }).on('keypress', handleKeypressADA);
    });
  }
  /* END GUTENBERG SCRIPTS */

  // news filters dropdown
  if ( $('.news-filters__toggle').length ) {
    $('.news-filters__toggle').each(function(){
      $(this).on('click', function(){
        const dropdown = $(this).next();
        dropdown.slideToggle();
        $(this).toggleClass('active');
      }).on('keypress', handleKeypressADA);
    });
  }



  //Homepage carousel
  if($(".hs-content-holder").length >0){
    $(".hs-slide-holder").slick({
      arrows: false,
        dots: false,
        asNavFor: '.hs-content-holder'
    });
    $(".hs-content-holder").slick({
      arrows: true,
        dots: true,
        fade: true,
        speed: 1000,
        appendArrows: '.hs-content-holder__nav',
        appendDots: '.hs-content-holder__nav',
        asNavFor: '.hs-slide-holder',
    });
    
    const autoplayTL = gsap.timeline({
      repeat: -1,
      onRepeat: () => {
        $('.hs-content-holder__nav').find('.slick-next').click()
      }
    });
    
    autoplayTL.to('.homepage-carousel__autoplayindicator', {
      backgroundSize: '100% 8px',
      duration: 7,
      ease: 'none'
    });
    
    $('.hs-content-holder__playpause').on('click', function(){
      if ( $(this).hasClass('play') ) {
        autoplayTL.pause();
        $(this).removeClass('play').addClass('paused');
      } else {
        autoplayTL.play();
        $(this).removeClass('paused').addClass('play');
      }
    }).on('keypress', handleKeypressADA);
    
    $('.hs-content-holder').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      autoplayTL.seek(0);
    });

  }
  
// Check if user has already closed the violator in this session
// Check if user has already closed the violator in this session
if (sessionStorage.getItem("violatorClosed") === "true") {
  $(".violator-container")
    .removeClass("active")
    .css("display", "none"); // disable CSS transitions
}

// Check for violator on page load
if ($(".violator-container").length > 0) {
  $(".violator-closeOut").on("click", function () {
    $(".violator-container")
      .removeClass("active");
    sessionStorage.setItem("violatorClosed", "true");
  });
}



  checkForSlicks();



  // NAVIGATION SEARCH

  if($(".navigation-search").length > 0) {
    // console.log("navigation search working click click");
    $(".navigation-search button").on("click", function(){
      $(".navigation-search").toggleClass('active');
    });
  }

  if ( $('.navigation-knowledge').length ) {
    $('.navigation-knowledge > button').on('click', function(){
      if ( isMobile ) {
        $('.navigation-knowledge').toggleClass('active');
        if ( $('.navigation-knowledge').hasClass('active') ) {
          $('.site-header__mobile-navigation__container').removeClass('active');
          $('.site-header__mobile-navigation__toggle').removeClass('active');
          $('.site-header__mobile-navigation__toggle').attr('aria-expanded', 'false');
        }
      }
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.site-header__mobile-navigation__toggle').length ) {
    $('.site-header__mobile-navigation__toggle').on('click', function(){
      $('.site-header__mobile-navigation__container').toggleClass('active');
      $(this).toggleClass('active');

      if ( $(this).hasClass('active') ) {
        $('.navigation-knowledge').removeClass('active');
      }

      $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true');
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.site-header__mobile-navigation #primary-mobile-menu > li.menu-item-has-children > a').length ) {
    $('.site-header__mobile-navigation #primary-mobile-menu > li.menu-item-has-children > a').on('click', function(e){
      e.preventDefault();
      $(this).next().slideToggle();
      $(this).toggleClass('active');
    }).on('keypress', handleKeypressADA);
  }
  
  if ( $('.microsite-container__nav-mobiletoggle').length ) {
    $('.microsite-container__nav-mobiletoggle').each(function(index){
      $(this).attr('aria-controls', 'microsite-nav-' + index);
      $(this).attr('aria-expanded', 'false');
      $(this).next().attr('id', 'microsite-nav-' + index);
      
      $(this).on('click', function(){
        $(this).next().slideToggle();
        $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true' );
      });
    });
  }



}); // document ready end

/*
 * Window Resize
 ***************************/
$(window).resize(function(){
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
  isMobile = ( windowWidth <= mobileBreakpoint );
}); // end window resize functions

/*
 * Window Scroll
 ***************************/
$(window).on('scroll', function() {
  navTrigger = scrollTop;
  scrollTop = $(this).scrollTop();
}); // end window scroll functions

/*
 * Functions
 ***************************/
function checkForSlicks(){
  if($('.slick').length > 0){
    $(".slick").each(function(i,v){
      console.log(v);
      $(v).slick({
        adaptiveHeight: true,
      });
    })

  }
}

 function gutenbergSlickify(el) {
   const count = $(el).find('figure').length;

   const captions = [];

   $(el).find('figure').each(function(){
     if ( $(this).find('figcaption').length ) {
       $(this).addClass('has-caption');
       captions.push( $(this).find('figcaption').clone(true) );
       $(this).find('figcaption').remove();
     } else {
       captions.push('<div style="height:10px;"></div>');
     }
   });

   $(el).find('.blocks-gallery-item').each(function(){
     $(this).addClass('slick-gallery-item').removeClass('blocks-gallery-item');
   });

   $(el).find('.blocks-gallery-item__caption').each(function(){
     $(this).addClass('slick-gallery-item__caption').removeClass('blocks-gallery-item__caption');
   });

   $(el).addClass('slick-gallery-grid').removeClass('blocks-gallery-grid');

   // $(el).parent().addClass('slick-gallery').removeClass('wp-block-gallery').append('<div class="slick-gallery-nav"><div class="slick-gallery-nav__count"><b><span class="slick-gallery-nav__count__cur">1</span></b> of <b>' + count +'</b></div></div>');

   $(el).removeClass('wp-block-gallery').wrap('<div></div>');
   const parent = $(el).parent();
   parent.addClass('slick-gallery').removeClass('wp-block-gallery').append('<div class="slick-gallery-nav"><div class="slick-gallery-nav__inner"><div class="slick-gallery-nav__count"><b><span class="slick-gallery-nav__count__cur">1</span></b> / <b>' + count +'</b></div><div class="slick-gallery-nav__captions-outer"><div class="slick-gallery-nav__captions"></div></div></div>');


   const nav = $(el).parent().find('.slick-gallery-nav');
   const captionsContainer = nav.find('.slick-gallery-nav__captions');
   for (let i = 0; i < captions.length; i++) {
     captionsContainer.append( captions[i] );
   }
   
   
   // $('.slick-arrow').remove();
   // const test = $(el).find('.slick-arrow').addClass('test');
   // console.log(test);
   // $(el).find('.slick-arrow').each(function(){
   //    $(this).addClass('test');
   //  });
   //  

   captionsContainer.slick({
     adaptiveHeight: true,
     arrows: false,
     swipe: false,
     fade: true
   });

   $(el).slick({
     adaptiveHeight: true,
     prevArrow: prevArrow,
     nextArrow: nextArrow,
     // appendArrows: nav,
     asNavFor: captionsContainer,
     dots: true,
     slidesToShow: 1,
   });

   $(el).on('beforeChange', function(event, slick, currentSlide, nextSlide){
     nav.find('.slick-gallery-nav__count__cur').text(nextSlide + 1);
   });
 }
